import Marquee from "react-fast-marquee";

const values = ["Healing", "Trust", "Commitment", "Legacy", "Faith", "Communication", "Grace"];

export const ValuesMarquee = () => (
  <div className="py-10 border-y border-[#E6DFD5] bg-[#F3EFEA]/60" data-testid="values-marquee">
    <Marquee speed={28} gradient={false} autoFill>
      {values.map((v, i) => (
        <span key={v} className="flex items-center">
          <span
            className={`font-serif-display text-2xl md:text-3xl text-[#2C2A28] px-6 ${
              i % 2 === 1 ? "italic text-[#8A5A44]" : "font-medium"
            }`}
          >
            {v}
          </span>
          <span className="text-[#C4B299] text-lg">•</span>
        </span>
      ))}
    </Marquee>
  </div>
);
